import http from './axios';

export interface DimensionDto {
  id?: number;
  isFieldsChange?: number;
  // 目录分类
  dimCategoryId?: number;
  dimCategoryName?: string;
  // 维度编码
  dimCode?: string;
  // 维度名称
  dimName?: string;
  // 维度标签
  dimLabel?: string;
  // 维度描述
  dimKind?: number;
  // 排序
  dimSort?: number;
  // 维度描述
  dimDescription?: string;
  // 使用状态，0-启用，1-禁用
  status?: number;
  // 维度属性列表
  dimFieldList?: any[];
  // 系统维度数据同步定义
  dimSyncDefs?: any;
  approveStatus?: number;
}

export interface DimensionItemDto {
  id?: number;
  // 维度编码
  dimCode?: string;
  // 属性编码
  fieldCode?: string;
  // 属性名称
  fieldName?: string;
  // 属性类型
  fieldType?: number;
  // 属性排序
  fieldSort?: number;
  // 钻取层级
  drillLevel?: number;
  // 使用状态
  status?: number;
}

export default class DimensionServices {
  private readonly category_api = '/v1/dimtable/category';
  private readonly list_api = '/v1/dimtable/list';
  private readonly tree_api = '/v1/dimtable/tree';
  private readonly info_api = '/v1/dimtable/info';
  private readonly save_api = '/v1/dimtable/save';
  private readonly update_api = '/v1/dimtable/update';
  private readonly remove_api = '/v1/dimtable/delete';
  private readonly excuteSql_api = '/v1/dimtable/excute-sql';
  private readonly excuteSubSql_api = '/v1/subtabledef/excute-sql';
  private readonly item_list_api = '/v1/dictitem/list'; // 获取详情数据接口
  private readonly source_api = '/v1/sources?projectId=1';
  private readonly source_database_api = '/v1/sources/1/databases';
  private readonly source_tables_api = '/v1/sources/1/tables';
  private readonly source_columns_api = '/v1/sources/1/table/columns';

  constructor() {}

  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getEnableList(params?: object): Promise<any> {
    // 0-新建待提交，1-编辑待提交，2-新建已提交，3-编辑已提交，4-新建已审批，5-编辑已审批，6-新建已驳回，7-编辑已驳回
    return await this.getList({ ...params, status_eq: 0, approveStatus_ge: 4, approveStatus_le: 5 });
  }

  async getTree(params?: object): Promise<any> {
    // approveStatus_eq approveStatus_eq
    let res: any = await http.get(this.tree_api, { params: params });
    let list = res.payload;
    return list.map((v: any) => {
      return {
        label: v.sysDim.dimName,
        value: v.sysDim.dimCode,
        children: v.dimFieldList.map((item: any) => ({ label: item.fieldName, value: item.fieldCode }))
      };
    });
  }

  async getCategory(params?: object): Promise<any> {
    let res: any = await http.get(this.category_api, { params: params });
    return res.payload;
  }

  async getItemList(params?: object): Promise<any> {
    let res: any = await http.get(this.item_list_api, { params: params });
    return res.payload;
  }

  async getInfo(id: string | number) {
    let res: any = await http.get(this.info_api + '/' + id);
    return res.payload;
  }

  async getSourceList() {
    let res: any = await http.get(this.source_api);
    return res;
  }

  async getDatabaseList() {
    let res: any = await http.get(this.source_database_api);
    return res.payload;
  }

  async getTableList(dbName: string) {
    let res: any = await http.get(this.source_tables_api, { params: { dbName } });
    return res.payload;
  }

  async getColumnsList(dbName: string, tableName: string) {
    let res: any = await http.get(this.source_columns_api, { params: { dbName, tableName } });
    return res.payload;
  }

  async add(data: DimensionDto) {
    const params = { ...data, dimSort: '1', dimCode: 'DIM_' + data.dimCode };
    let res: any = await http.post(this.save_api, params);
    return res.header?.code == 200 ? res.payload : false;
  }

  async update(data: DimensionDto): Promise<boolean> {
    let res: any = await http.post(this.update_api, data);
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.remove_api, [id]);
    return res.header?.code == 200;
  }

  async excuteSql(data: any) {
    let res: any = await http.post(this.excuteSql_api, data);
    return res;
  }

  async excuteSubSql(data: any) {
    let res: any = await http.post(this.excuteSubSql_api, data);
    return res;
  }
}
